var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTableDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0176BC",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 3,
    fill: "#0176BC",
    stroke: "#0176BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 15,
    height: 5,
    stroke: "#0277BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 13,
    stroke: "#0277BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 13,
    stroke: "#0277BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 0.5,
    width: 5,
    height: 13,
    stroke: "#0277BD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "#0176BC",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.8571H14.8571V15H14.1429V12.8571H12V12.1429H14.1429V10H14.8571V12.1429H17V12.8571Z",
    fill: "#0176BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTableDataIcon);
export default __webpack_public_path__ + "static/media/AddTableDataIcon.576c4302.svg";
export { ForwardRef as ReactComponent };